module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_2_1_1-ac50d813c5143e3ad6ff413c295c9ca2.webp";